import React, { useState, useEffect } from "react";
import pcImg from "../../asset/images/wyd.jpg";
import mobileImg from "../../asset/images/wyd_mobile.jpg";
import classes from "./LandingPage.module.css";

const LandingPage = (children) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [scrollOffset, setScrollOffset] = useState(window.pageYOffset);
  let imgUrl = windowWidth > 700 ? pcImg : mobileImg;

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    const handleScrollOffset = () => {
      setScrollOffset(window.pageYOffset);
    };
    window.addEventListener("resize", handleWindowResize);
    window.addEventListener("scroll", handleScrollOffset);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
      window.removeEventListener("scroll", handleScrollOffset);
    };
  }, []);

  let alpha = 0.85 * (Math.min(300, scrollOffset) / 300);
  return (
    <div>
      <div
        className={classes.bg}
        style={{
          backgroundImage: `url(${imgUrl})`,
        }}
      ></div>
      <div id="test" style={{ backgroundColor: `rgba(0, 0, 0, ${alpha}` }}>
        {children}
      </div>
    </div>
  );
};

export default LandingPage;
